import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import transCs from '../locales/cs/translation.json';
import transDe from '../locales/de/translations.json';
import transEn from '../locales/en/translations.json';

import customerCs from '../locales/cs/customer.json';
import customerDe from '../locales/de/customer.json';
import customerEn from '../locales/en/customer.json';

import commonCs from '../locales/cs/common.json';
import commonDe from '../locales/de/common.json';
import commonEn from '../locales/en/common.json';

import adminCs from '../locales/cs/admin.json';
import adminDe from '../locales/de/admin.json';
import adminEn from '../locales/en/admin.json';

import { ELanguage } from '../types';

export const supportedLanguages: ELanguage[] = [ELanguage.cs, ELanguage.de, ELanguage.en];

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'cs',
        supportedLngs: supportedLanguages,
        debug: false,
        resources: {
            en: {
                translation: transEn,
                customer: customerEn,
                admin: adminEn,
                common: commonEn,
            },
            cs: {
                translation: transCs,
                customer: customerCs,
                admin: adminCs,
                common: commonCs,
            },
            de: {
                translation: transDe,
                customer: customerDe,
                admin: adminDe,
                common: commonDe,
            },
        },
    });

export default i18n;
